module.exports = __webpack_public_path__ + "static/img/4.1623c63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/4.png
// module id = KUJH
// module chunks = 0